<!-- This part of code needs to be changes in case there is requirment in the UI to be fit to on device break point
and esnure it worked with all the device in landscape and portarit -->
<router-outlet></router-outlet>
